import TrainingSessionLesson from 'actions/training/session-lesson';

export default TrainingSessionLesson.createReducer();